import axios from 'axios'
import router from '@/router'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import md5 from 'js-md5'

// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url process.env.VUE_APP_BASE_API
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + getToken()
      config.headers['X-Request-Id'] = +new Date() + md5(store.getters.name)
    }
    return config
  },
  error => {
    // do something with request error
    console.log('111error') // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 10000) {
      if (res.code === 10103) {
        router.push({ path: '/repassword' })
      } else if (res.code === 10112 || res.code === 1000 || res.code === 2005 || res.code === 2000 || res.code === 1001 || res.code === 1002 || res.code === 1003 || res.code === 1004 || res.code === 2001 || res.code === 2002
        || res.code === 2003 || res.code === 2004 || res.code === 3100 || res.code === 10001 || res.code === 10006 || res.code === 30000) return res
      else {
        //   Message({
        //     message: res.message || 'Error',
        //     type: 'error',
        //     duration: 5 * 1000
        //   })
        return res
      }
      return Promise.reject(res.message || 'Error')
    } else {
      return res
    }
  },
  error => {
    if (error.message.includes('timeout')) {
      Message({
        message: '网络请求超时，稍后刷新尝试',
        type: 'error'
      })
      return Promise.reject(error)
    }
    if (error.response.data.code === 10110) {
      // to re-login
      MessageBox.confirm('用户信息已过期，请重新登录', '重新登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    } else {
      // Message({
      //   message: error.response.data.message || error.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      return Promise.reject(error)
    }
  }
)

export default service
